import axios from "axios";
import { config } from "../../utils/axiosconfig";
import { base_url } from "../../utils/baseUrl";
const getBrandModels = async () => {
  const response = await axios.get(`${base_url}brandmodel/`);

  return response.data;
};

const createBrandModel = async (brand) => {
  const response = await axios.post(`${base_url}brandmodel/`, brand, config);

  return response.data;
};
const updateBrandModel = async (brand) => {
  const response = await axios.put(
    `${base_url}brandmodel/${brand.id}`,
    { title: brand.brandData.title },
    config
  );

  return response.data;
};
const getBrandModel = async (id) => {
  const response = await axios.get(`${base_url}brandmodel/${id}`, config);

  return response.data;
};

const deleteBrandModel = async (id) => {
  const response = await axios.delete(`${base_url}brandmodel/${id}`, config);

  return response.data;
};

const brandModelService = {
 getBrandModels,
 createBrandModel,
 getBrandModel,
 updateBrandModel,
 deleteBrandModel,
};

export default brandModelService;
